import { render, staticRenderFns } from "./TranslateList.vue?vue&type=template&id=17d3c737"
import script from "./TranslateList.vue?vue&type=script&lang=js"
export * from "./TranslateList.vue?vue&type=script&lang=js"
import style0 from "./TranslateList.vue?vue&type=style&index=0&id=17d3c737&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports